import { Filter as FilterIcon, Plus, Search } from 'lucide-react';
import React from 'react';
import Filter from './filter/Filter';
import BaseContainer from './containers/BaseContainer';
import Bar from './elements/Bar';
import NavList from './elements/NavList';
import useWindowSize from '../hooks/useWindowSize';
import { debounce } from 'lodash';
import { SpinnerOverlay } from '@/components/ui/Spinner';

export default function LeftPanel({
  data,
  makeActive,
  active,
  onSearch,
  addItem,
  onFilter,
  title,
  filteredValues,
  fetchMore,
  dataLength,
  hasMore,
  disableAdd = false,
  permission = 2,
  loading,
}: {
  data?: any;
  makeActive?: any;
  active?: any;
  onSearch?: any;
  addItem?: any;
  onFilter?: any;
  title?: any;
  filteredValues?: any;
  fetchMore?: any;
  dataLength?: any;
  hasMore?: any;
  disableAdd?: boolean;
  permission?: number;
  loading?: any;
  [key: string]: any;
}) {
  const [, windowHeight] = useWindowSize();

  const handleDebouncedSearch = debounce((e) => {
    onSearch(e);
  }, 1000);

  const prepareData = () =>
    (data || []).map((item) => ({ ...item, text: item?.title, status: item?.status }));

  const content = () => {
    const items = [];

    if (filteredValues) {
      items.push(
        <Filter key={1} filteredValues={filteredValues}>
          <FilterIcon className="h-4 w-4" data-testid="left-panel-filter-btn" />
        </Filter>
      );
    }

    if (permission === 2 && !disableAdd) {
      items.push(
        <Plus key={2} className="h-4 w-4" data-testid="left-panel-add-btn" onClick={addItem} />
      );
    }

    return items;
  };

  return (
    <BaseContainer width="340px" className="border-r border-neutral-150">
      <Bar text={title} count={data?.length} content={content()} />

      {/* Search strip */}
      <div className="p-3 border-b border-neutral-150 bg-neutral-25/50">
        <div className="relative">
          <Search
            size={13}
            className="absolute left-2.5 top-1/2 -translate-y-1/2 text-neutral-400"
          />
          <input
            placeholder="Vyhledat..."
            data-testid="left-panel-search-input"
            onChange={handleDebouncedSearch}
            className="h-8 w-full bg-white border border-neutral-200 rounded pl-8 pr-3 text-xs placeholder:text-neutral-400 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all"
          />
        </div>
      </div>

      <div style={{ height: 'calc(100vh - 180px)' }} className="overflow-y-auto">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <SpinnerOverlay />
          </div>
        ) : (
          <NavList
            height={(windowHeight || 500) - 180}
            data={prepareData()}
            makeActive={makeActive}
            active={active}
            hasMore={hasMore}
            dataLength={dataLength}
            fetchMoreData={fetchMore}
          />
        )}
      </div>
    </BaseContainer>
  );
}
